import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ApiBusinessLicenceConstants } from "../../../../shared/constants/api-constants/api-business-licence.constants";
import { map } from "rxjs/operators";
let BlService = class BlService {
    http;
    constructor(http) {
        this.http = http;
    }
    updateBusinessLicenceBusinessOwner(recipient, key) {
        return this.http.post(`${ApiBusinessLicenceConstants.URL}/${key}/${ApiBusinessLicenceConstants.FUNCTION_UPDATE_BUSINESS_OWNER}`, recipient);
    }
    getApplicationSetPropertiesObservable(applicationId, params) {
        return this.http.post(`${ApiBusinessLicenceConstants.URL}/${applicationId}/${ApiBusinessLicenceConstants.FUNCTION_SET_PROPERTIES}`, params)
            .pipe(map((response) => {
            return response;
        }));
    }
    static ctorParameters = () => [
        { type: HttpClient }
    ];
};
BlService = __decorate([
    Injectable({
        providedIn: "root"
    })
], BlService);
export { BlService };
